import React from 'react';
import { Box } from '@mui/material';
import Link from 'next/link';

const GridCellLinkV2 = ({ href, children, styles = {}, target, ...rest }) => {
  return (
    <Box
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        color: (theme) => theme.palette.blues.primaryBlue,
        ...styles,
      }}
      {...rest}
    >
      <Link href={href} target={target}>
        {children}
      </Link>
    </Box>
  );
};

export default GridCellLinkV2;
